export function dispatchEvent(event: CustomEvent) {
  window.dispatchEvent(event);
}
